import 'UI/Widget/Forms/Control/XhrAutocomplete'
import 'Cadastre/Data/Cadnums'
import 'Cadastre/UI/Cadastre'
import 'Cadastre/UI/MapForm'

/** @namespace UI.Widget.Forms.Control */
NS("UI.Widget.Forms.Control");

/**
 * @class
 * @extends UI.Widget.Forms.Control.Text
 */
UI.Widget.Forms.Control.Cadastre = Class(UI.Widget.Forms.Control.XhrAutocomplete,
	/** @lends UI.Widget.Forms.Control.Cadastre.prototype */
	{
		template: 'UI/Widget/Forms/Control/Cadastre/Control',
		cadastreFormClass: 'Cadastre.UI.Cadastre',
		mapFormClass: 'Cadastre.UI.MapForm',

		value: null,
		item: null,
		cadastreForm: null,

		$button_info: null,
		$button_select: null,


		createElement: function() {
			this.$element = UI.Template.$render(this.template, {
				control: this
			});

			this.$button_info = this.$name('info');
			this.$button_select = this.$name('select');

			this.$button_info.on('click', this.onInfoClick.bind(this));
			this.$button_select.on('click', this.onSelectClick.bind(this));

		},

		insertElement: function() {

			this.ParentCall();

			this.autocomplete.on("select", function(args) {
				var item = args.item;

				this.setValue({
					id: item.id,
					cadnum: item.cadnum
				});
			}.bind(this))
		},

		onInfoClick: async function (e) {
			var ds = Util.create('Cadastre.Data.Cadnums');

			this.cadastreForm = Util.create(this.cadastreFormClass, [this, {
				id: this.value ? this.value.id : null,
			}])
				.on("destroy", function () {
					delete this.cadastreForm;
				}, this)
				.render()
				.appendTo(this.$element);
		},
		onSelectClick: async function (e) {
			var ds = Util.create('Cadastre.Data.Cadnums');

			this.cadastreForm = Util.create (this.mapFormClass, [this, {
				ds: ds,
				item: this.value ? (await ds.get({id: this.value.id})).item : null
			}])
				.on("destroy", function () {
					delete this.cadastreForm;
				}, this)
				.on('select', function (value) {
					this.setValue(value);
					this.updateElement(value);
				}, this)
				.render()
				.appendTo(this.$element);
		},
		val: function(val) {
			if (val !== undefined) {
				if (this.$element) {
					this.$element.find('input[type=text]').val(val);
				}

				return this;
			} else {
				return this.$element ? this.$element.find('input[type=text]').val() : null;
			}
		},
		setValue: function(value) {
			if (value)
				this.$element.find('.ctrl-cadastre-info').show();
			else
				this.$element.find('.ctrl-cadastre-info').hide();
			this.value = value;
			this.ParentCall();
		},
		updateElement: function(value) {
			if (value)
				this.$element.find('.ctrl-cadastre-info').show();
			else
				this.$element.find('.ctrl-cadastre-info').hide();
			this.value = value;
			this.textControl.plugin(UI.Plugin.XhrAutocomplete).read();
			this.$element.find('input[type=text]').val(Util.isDefined(value) ? value.cadnum : null);
		},
        editMode () {
            this.ParentCall()
            this.$("input[type='text']").show()
        },
        viewMode () {
            this.ParentCall()
            this.$("input[type='text']").hide()
        },
	}
);
